import { Container, Row, Col, Card } from "react-bootstrap";

export default function Railways() {
  return (
    <Container fluid className="py-5 bg-white">
      <h2 className="text-center text-primary fw-bold">Railways</h2>
      <p className="mt-3 text-center text-secondary fs-5">
        Enhancing railway networks to ensure safe, efficient, and modern transportation systems.
      </p>

      <Row className="mt-4 justify-content-center g-4">
        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0">
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Metro & High-Speed Rail</Card.Title>
              <Card.Text className="text-secondary">
                Developing metro rail and high-speed corridors for urban transit.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col xs={12} md={6} lg={4}>
          <Card className="shadow border-0">
            <Card.Body>
              <Card.Title className="text-primary fw-bold">Railway Bridges & Tunnels</Card.Title>
              <Card.Text className="text-secondary">
                Constructing railway overpasses, bridges, and tunnels for seamless travel.
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
